import { SpecifiedCommercialTransactionLaw } from "@/features/misc";
import Head from "next/head";

export default function SpecifiedCommercialTransactionLawPage() {
	return (
		<>
			<Head>
				<title>特定商取引法に基づく表記 | ケアミー</title>
			</Head>

			<SpecifiedCommercialTransactionLaw />
		</>
	);
}
